import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { selectedNodeSelector } from '@cbridge-packages/node';
import { StreamAction } from '../stream.action';
import { StreamTranslator } from '../stream.translator';

type IState =
  & IGetSelectorStateType<typeof selectedNodeSelector>;

type IDependencies = IClientApiDependencySegment;

export const createStreamEpic: IEpic<IState, IDependencies> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(StreamAction.create.started),
  withLatestFrom(state$),
  mergeMap(([{ params, resolve, reject }, state]) => {
    const nodeId = selectedNodeSelector(state);

    return dependencies.api.createStream({ nodeId, ...StreamTranslator.toApi(params) }).pipe(
      mergeMap((response) => {
        resolve?.();
        return [
          StreamAction.create.done({ params, result: response }),
          DetailsSidebarAction.close(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          StreamAction.create.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
